module.exports = __webpack_public_path__ + "static/media/avatar_frank_penning.3cbec542.jpg";